export enum DataType {
    String = 'string',
    Boolean = 'boolean',
    BigDecimal = 'bigdecimal',
    Integer = 'integer',
    List = 'list',
    Numeric = 'numeric',
    Date = 'date',
    DateTime = 'datetime',
    HTML = 'html',
    Link = 'link',
    DateRange = 'daterange',
    Long = 'long',
    Double = 'double',
    dateRangeList  = "DateRangeList"
}
